import { message } from 'antd'
import Iconfont from '@/components/iconfont/iconfont'
import React from 'react'

type MsgType = 'success' | 'info' | 'error' | 'warning'
/**
 * 重置antd消息样式
 * @param type 消息类型
 * @param content 消息内容
 */
const $msg = (type: MsgType, content: string, duration: number = 1) =>
    message[type]({
        content: content || ' ',
        className: `msg__${type}`,
        icon: (
            <Iconfont
                name={`icon${type}`}
                size={18}
                style={{
                    marginRight: '10px',
                }}
            />
        ),
        duration,
    })

export default $msg
